import { PropertySearchModel } from './PropertySearchModel';
import { PropertySearchListingV3Model } from './PropertySearchListingV3Model';
import { PropertyAssetViewModel } from './PropertyAssetViewModel';
import { PropertySearchResultV3Model } from './PropertySearchResultV3Model';
import { SearchGeoModel } from './SearchGeoModel';
import * as _ from 'lodash';
import { CoordinateModel } from './CoordinateModel';

declare function initPropertySearchMap(lat: number, lng: number, zoom: number, radius: number, searchCallback: any): any;
declare function addPropertyMarker(info: any);
declare function addPropertyOutsideMarker(info: any);
declare function setPropertyMarkerClusters();
declare function panMapToCoords(lat: number, lng: number);
declare function addPill(data: any, actionSource: number);
declare function attemptLocationMatchPartial(location: string, callbackFunc: any);
declare function heightCheck(elem: string);
declare function clearPropertyMarkers();
declare function setMapZoomLevel(zoom: number, radius: number);

export class PropertySearchV5 {

    /*pageNo: number;
    pageSize: number;
    searchField: string;
    searchTerm: string;
    orderID: number;
    departmentName: string;
    departmentID: number;
    categoryName: string;
    isResidential: boolean;
    isResidentialSale: boolean;
    isResidentialLetting: boolean;
    isCommercial: boolean;
    isAgricultural: boolean;
    studentProperties: boolean;
    auctionProperties: boolean;
    priceTypeId: number;
    priceMin: number;
    priceMax: number;
    bedroomsMin: number;
    location: string;
    searchRadius: number;
    mapLongitude: number;
    mapLatitude: number;
    mapZoom: number;
    mapRadius: number;
    noMap: boolean;
    includeLetOrSold: boolean;
    propertyTypes: number[];
    searchScopes: SearchScopeModel[];
    searchGeos: SearchGeoModel[];
    coordinates: CoordinateModel[]
    */

    public searchMap;
    public isHomePage: boolean;
    public isHomePageInitialisation: boolean;
    public totalGeoPoints: number = 0;

    public defaultLatitude = 54.974248;
    public defaultLongitude = -1.603980;

    public defaultZoom = 15;
    public defaultRadius = 500;
    public defaultSearchRadius = 0;
    public defaultSearchRadiusHome = 0;

    public radiusOptions: any[] = [];
    public lettingPrices: any[] = [];
    public lettingWeeklyPrices: any[] = [];
    public studentWeeklyPrices: any[] = [];
    public salePrices: any[] = [];
    public propertyTypeOptions: any[] = [];
    public currentActivePrices: any[] = [];

    public infiniteScrollActive = false;
    public infiniteScrollEof = false;

    public xDown = null;                                                        
    public yDown = null;

    public propertyGroup = 1;

    public propertySearchModel = {
        pageNo: 1,
        pageSize: 12,
        searchField: '',
        searchTerm: '',
        orderID: 1,
        departmentID: 0,
        departmentName: 'residential',
        categoryName: 'lettings',
        priceFrequencyId: 0,
        priceMin: 0,
        priceMax: 0,
        bedroomsMin: 0,
        location: '',
        searchRadius: this.defaultSearchRadius,
        mapLongitude: this.defaultLongitude,
        mapLatitude: this.defaultLatitude,
        mapZoom: this.defaultZoom,
        mapRadius: this.defaultRadius,
        noMap: true,
        includeLetOrSold: false,
        propertyTypes: [],
        searchScopes: [],
        searchGeos: [],
        coordinates: [],
        gridViewMode: '3x' // 1x, 2x, 3x, mapx
    } as PropertySearchModel;

    /*searchGeos: [{
        placeId: 'ChIJzWRvDH6FfUgRkWGncrBS4gs',
        typeId: 1,
        name: 'Newcastle upon Tyne, UK',
        mainText: 'Newcastle upon Tyne',
        vicinity: '',
        scope: 'locality',
        latitude: 54.978252,
        longitude: -1.6177800000000389
    }]*/

    constructor() {
    }

    showHideMapControls(): void {
        if (this.propertySearchModel.noMap) {
            $('.dyn-map-visibility').fadeOut(0);
        } else {
            $('.dyn-map-visibility').fadeIn(200);
        }

        if (this.propertySearchModel.noMap) {
            $('.dyn-map-ctrls-visibility').fadeOut(0);
        } else if (this.mediaMapCheck() === 'none') {
            $('.dyn-map-ctrls-visibility').fadeOut(0);
        } else {
            $('.dyn-map-ctrls-visibility').fadeIn(300);
        }
    }

    public run(): void {
        console.log(`PropertySearchComponent run ${localStorage.getItem("bm-pty-search-init") === "1"}`);

        // Redirected from deleted property
        let searchFromDeletedStr = $('#hdnSearchFromDeleted').val().toString();
        let isRoutedFromDeleted = searchFromDeletedStr === 'yes';
        console.log(`isRoutedFromDeleted ${isRoutedFromDeleted}`);
        if (isRoutedFromDeleted === true)
        {
            localStorage.setItem("bm-pty-search-init", "0");
            localStorage.setItem("bm-pty-from-search", "0");
        }

        // Is this the home page or the search listing
        this.isHomePage = false;
        this.isHomePageInitialisation = false;

        this.setSearchDepartment(this.getSearchDepartment());
        this.setSearchCategory(this.getSearchCategory());
        this.setSearchLocation(this.getSearchLocation());

        // Load search variables
        this.loadRadiusOptions();
        this.loadLettingPrices();
        this.loadLettingWeeklyPrices();
        this.loadStudentWeeklyPrices();
        this.loadSalePrices();
        this.loadPropertyTypeOptions();

	    // Not disabled for mobile devices
        if (this.mediaMapCheck() === 'none') {
            this.showHideMapControls();
        }
        if (this.propertySearchModel.noMap) {
            this.showHideMapControls();
        }

        this.performCardAutoHeight(4);

        // Load the page and filters
        if (localStorage.getItem("bm-pty-search-init") === "1") {
            // This has been referred from the home page

            // Set the model from localStorage
            this.propertySearchModel = JSON.parse(localStorage.getItem("bm-pty-search"));

            // Amend the grid view type
            if (this.mediaMapCheck() === 'none') {
                this.setGridViewMode('3x');
            } else if (this.getSearchCategory() === 'sales') {
                this.setGridViewMode('1x');
            }

	        // Set map zoom and radius levels (if default zoom level only)
            if (this.propertySearchModel.mapRadius === this.defaultRadius) {
                this.setMapDefaultZoom(2);
            }

            // Preset search options in UI
            this.setUiThread();

	        // Initialse the map
            this.setUiMap();

            // Run the search automatically upon page load
            this.executeHomeRedirectSearch();
        } else if (localStorage.getItem("bm-pty-from-search") === "1") {
            // This has been referred from a property details page

            // Set the model from localStorage
            this.propertySearchModel = JSON.parse(localStorage.getItem("bm-pty-search"));

            // Amend the grid view type
            if (this.mediaMapCheck() === 'none') {
                this.setGridViewMode('3x');
            } else if (this.getSearchCategory() === 'sales') {
                this.setGridViewMode('1x');
            }

            // Preset search options in UI
            this.setUiThread();

            // Initialse the map
            this.setUiMap();

            // Run the search automatically upon page load
            this.executeQuickSearchNoUpdatePagination();
        } else {
            // Not referred (could be navigation from menu or direct link)

            // Amend the grid view type
            if (this.mediaMapCheck() === 'none') {
                this.setGridViewMode('3x');
            } else if (this.getSearchCategory() === 'sales') {
                this.setGridViewMode('1x');
            }

            // Save fresh search model to localStorage
            localStorage.setItem("bm-pty-search", JSON.stringify(this.propertySearchModel));
	        
            // Set map zoom and radius levels (if default zoom level only)
	        if (this.propertySearchModel.mapRadius === this.defaultRadius) {
            	this.setMapDefaultZoom(2);
            }

            // Preset search options in UI
            this.setUiThread();

            // Initialse the map
            let locationFromHidden = $('#hdnSearchLocationName').val().toString().trim();
            if (locationFromHidden.length > 0) {
                // Looking up location to get initial lat/long values
                attemptLocationMatchPartial(locationFromHidden, this.delayedLoadMapWithCoords);
            }
            else {
		        // Initialse the map
                this.setUiMap();
		
		        // Run the search automatically upon page load
                this.executeQuickSearch();
            }            
        }
    }
    mediaMapCheck = () => {
        let mediaMapCheck = document.getElementById('mediaMapCheck'),
            mediaMapStyles = window.getComputedStyle(mediaMapCheck),
            mediaMapDisplay = mediaMapStyles.getPropertyValue('display');
        return mediaMapDisplay;
    }
    
    updatePagination = (page) => {
        // Update the page number
        this.propertySearchModel.pageNo = page;
        if (this.propertySearchModel.pageNo == null || this.propertySearchModel.pageNo == undefined || this.propertySearchModel.pageNo === 0) { this.propertySearchModel.pageNo = 1; }

        // Run the search automatically
        this.getPropertySearch(this.displayPropertySearch);
    }
    
    updateOrdering = (order: number) => {
        this.propertySearchModel.orderID = order;
        this.propertySearchModel.pageNo = 1;
        this.resetInfiniteScroll();

        // Run the search automatically
        this.getPropertySearch(this.displayPropertySearch);
    }
    
    setIncludeLetOrSold = (toInclude: boolean) => {
        this.propertySearchModel.includeLetOrSold = toInclude;
        this.propertySearchModel.pageNo = 1;
        this.resetInfiniteScroll();

        // Run the search automatically
        this.getPropertySearch(this.displayPropertySearch);
    }
    
    executeHomeRedirectSearch = () => {
        this.propertySearchModel.pageNo = 1;
        this.resetInfiniteScroll();

        // Run the search automatically
        this.getPropertySearch(this.displayPropertySearch);
    }

    executeQuickSearch = () => {
        this.propertySearchModel.pageNo = 1;
        this.resetInfiniteScroll();

        // Run the search automatically
        this.getPropertySearch(this.displayPropertySearch);
    }
    executeQuickSearchNoUpdatePagination = () => {
        if (this.propertySearchModel.pageNo == null || this.propertySearchModel.pageNo == undefined || this.propertySearchModel.pageNo === 0) { this.propertySearchModel.pageNo = 1; }
    
        // Run the search automatically
        this.getPropertySearch(this.displayPropertySearch);
    }

    executeAdvancedSearch = () => {
        this.propertySearchModel.pageNo = 1;
        this.resetInfiniteScroll();

        // Set model pills
        this.setSearchGeoModel();

        // Run the search automatically
        this.getPropertySearch(this.displayPropertySearch);
    }
    
    setSearchGeoModel = () => {
        this.propertySearchModel.searchGeos = [];

        let locations = $('.data-place-item');
        for (let i = 0; i < locations.length; i++) {
            this.propertySearchModel.mapLatitude = parseFloat(locations[i].getAttribute('data-lat'));
            this.propertySearchModel.mapLongitude = parseFloat(locations[i].getAttribute('data-lng'));

            this.propertySearchModel.searchGeos.push({
                placeId: locations[i].getAttribute('data-place-id'),
                typeId: parseInt(locations[i].getAttribute('data-type-id')),
                name: locations[i].getAttribute('data-loc-name'),
                vicinity: locations[i].getAttribute('data-vicinity'),
                mainText: locations[i].getAttribute('data-main-text'),
                scope: locations[i].getAttribute('data-scope'),
                latitude: parseFloat(locations[i].getAttribute('data-lat')),
                longitude: parseFloat(locations[i].getAttribute('data-lng'))
            } as SearchGeoModel);
        }
    }
    
    setPropertyTotalLabels = (total: number) => {
        // Update title total
        //$('.dyn-search-records-found').text(`${total} ${total === 1 ? 'property is available' : 'properties are available'}`);
    }
    
    setMapDefaultZoom = (levelId: number) => {
        if (this.propertySearchModel.mapLatitude === this.defaultLatitude) {
            // Lettings
            if (levelId === 1) {
                this.propertySearchModel.mapZoom = 16;
                this.propertySearchModel.mapRadius = 500;
            }
            // Sales | Commercial | Agricultural
            if (levelId === 2) {
                this.propertySearchModel.mapZoom = 13;
                this.propertySearchModel.mapRadius = 4000;
            }
        }
    }
    
    getPropertySearch = (callback) => {
        let bmApiUrl = window['__appConfig'].apiUrl;

        // Clean up current listing items
        $('.dyn-search-group1').html('');
        $('.dyn-search-group2').html('');
        $('.pagination').html('');
        $('#hdnNewPillAddedSinceSearch').val(0);

        // Clean up localStorage search init value
        localStorage.setItem("bm-pty-search-init", "0");
        localStorage.setItem("bm-pty-from-search", "0");
        
        // Set model basic fields
        this.propertySearchModel.location = $('#psearch-locality').val().toString();

        // Save search model to localStorage
        localStorage.setItem("bm-pty-search", JSON.stringify(this.propertySearchModel));

        // Set the search title
        // Format: [student or non-student] Properties to/for [sale or rent] in [area]
        let propertySearchTitle = "Properties to Rent";
        switch (this.propertySearchModel.departmentName) {
            case 'auction':
                propertySearchTitle = "Auction Properties";
                if (this.propertySearchModel.categoryName == 'sales') {
                    propertySearchTitle += " for Sale";
                } else if (this.propertySearchModel.categoryName == 'lettings') {
                    propertySearchTitle += " to Rent";
                }
                break;
            case 'commercial':
                propertySearchTitle = "Commercial Properties";
                if (this.propertySearchModel.categoryName == 'sales') {
                    propertySearchTitle += " for Sale";
                } else if (this.propertySearchModel.categoryName == 'lettings') {
                    propertySearchTitle += " to Rent";
                }
                break;
            case 'agricultural':
                propertySearchTitle = "Agricultural Properties";
                if (this.propertySearchModel.categoryName == 'sales') {
                    propertySearchTitle += " for Sale";
                } else if (this.propertySearchModel.categoryName == 'lettings') {
                    propertySearchTitle += " to Rent";
                }
                break;
            default:
                if (this.propertySearchModel.categoryName == 'sales') {
                    propertySearchTitle = "Properties for Sale";
                } else if (this.propertySearchModel.categoryName == 'lettings') {
                    propertySearchTitle = "Properties to Rent";
                } else if (this.propertySearchModel.categoryName == 'students') {
                    propertySearchTitle = "Student Properties to Rent";
                }
                break;
        }
        if (this.propertySearchModel.searchGeos != null && this.propertySearchModel.searchGeos.length > 0) {
            propertySearchTitle += " in ";
            for (var i = 0; i < this.propertySearchModel.searchGeos.length; i++) {
                var loc = this.propertySearchModel.searchGeos[i];
                if (i > 0) { propertySearchTitle += ", "; }
                propertySearchTitle += loc.name;
            }
        } else if (this.propertySearchModel.location != null && this.propertySearchModel.location != undefined && this.propertySearchModel.location.length > 0) {
            propertySearchTitle += " in " + this.propertySearchModel.location;
        }
        $('.dyn-search-title').text(propertySearchTitle);

        // Perform the API call
        $.ajax({
            url: `${bmApiUrl}api/3.0/PropertySearch/GetPropertySearch/`,
            type: "POST",
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            data: JSON.stringify(this.propertySearchModel),
            cache: false,
            crossDomain: true,
            xhrFields: {
                withCredentials: true
            },
            success: function (r) {
                console.log(`getPropertySearch success`);
                callback(r);
            },
            error: function (e) {
                console.log(e);
                callback(e);
            }
        });
    }
    
    displayPropertySearch = (data: PropertySearchResultV3Model) => {
        console.log(`displayPropertySearch start`);
        let bmCdnUrl = window['__appConfig'].cdnUrl;

        // Centre the map on the calculated centroid coordinates
        clearPropertyMarkers();
        panMapToCoords(data.filter.mapLatitude, data.filter.mapLongitude);

        // Button totals
        this.setPropertyTotalLabels(data.totalRecords);

        // Set structure options
        $('#dyn-search-group1').removeClass("row");
        $('#dyn-search-group2').removeClass("row");
        if (this.propertySearchModel.gridViewMode === "2x" || this.propertySearchModel.gridViewMode === "3x") {
            $('#dyn-search-group1').addClass("row");
            $('#dyn-search-group2').addClass("row");
        }

        // Results to display?
        if (data.totalRecords > 0) {

            // Set 1
            let itemsPerRow = parseInt(this.propertySearchModel.gridViewMode.replace('x', ''));
            let set1Min = 0;
            let set1Max = Math.ceil(data.resultItems.length / 2);
            
            // Need to ensure all rows are filled based upon 2 or 3 items per row etc
            if (itemsPerRow > 1) {
                if (data.resultItems.length <= itemsPerRow) {
                    set1Max = data.resultItems.length; // No need for 2nd group as not enough records
                } else {
                    // Page size is 12, ideally want 6 top and 6 bottom
                    let remainderX = set1Max % itemsPerRow;
                    set1Max = set1Max - remainderX; // We want full rows
                    if (remainderX > 0 && ((data.resultItems.length - set1Max) > itemsPerRow)) {
                        set1Max = set1Max + itemsPerRow; // If there are enough, add another row to the top.
                    }
                }
            }

            for (var i = 0; i < set1Max; i++) {
                let pItem = this.writePropertyItem(data.resultItems[i], bmCdnUrl, this.propertySearchModel.priceFrequencyId, 1);
                $(pItem).appendTo('.dyn-search-group1');
            }
            this.performCardAutoHeight(1);

            // Set 2 (if enough records)
            let set2Min = data.resultItems.length > set1Max ? set1Max : 0;
            let set2Max = set2Min > 0 ? data.resultItems.length : 0;

            if (set2Min > 0) {
                for (var i = set2Min; i < set2Max; i++) {
                    let pItem = this.writePropertyItem(data.resultItems[i], bmCdnUrl, this.propertySearchModel.priceFrequencyId, 2);
                    $(pItem).appendTo('.dyn-search-group2');
                }
                this.performCardAutoHeight(2);
            }

            $('.property-image-carousel .next-arrow-img, .property-image-carousel-nosplit .next-arrow-img').click(function (e) {
                e.preventDefault();
                const wrapper = $(this).parent();
                const imageContainer = $(wrapper).find('.property-image-carousel-items');
                let image = $(wrapper).find('.property-image-carousel-item').first();
                $(image).remove();
                $(image).appendTo(imageContainer);
            });

            $('.property-image-carousel .prev-arrow-img, .property-image-carousel-nosplit .prev-arrow-img').click(function (e) {
                e.preventDefault();
                const wrapper = $(this).parent();
                const imageContainer = $(wrapper).find('.property-image-carousel-items');
                let image = $(wrapper).find('.property-image-carousel-item').last();
                $(image).remove();
                $(image).prependTo(imageContainer);
            });
	    
            if (!this.propertySearchModel.noMap) {
                // Set map markers (within radius)
                if (data.resultMapItems != null) {
                    for (var i = 0; i < data.resultMapItems.length; i++) {
                        // Add marker to map
                        addPropertyMarker(data.resultMapItems[i]);
                    }
                }

                // Set map markers (outside radius)
                if (data.resultMapOutsideItems != null) {
                    for (var i = 0; i < data.resultMapOutsideItems.length; i++) {
                        // Add marker to map
                        addPropertyOutsideMarker(data.resultMapOutsideItems[i]);
                    }
                }

                // Set marker clustering
                setPropertyMarkerClusters();
            }

            this.setupImageDraggableEvents();
            this.displayFeaturedPropertyGroup(this.propertyGroup); // dyn1 - immediately
            this.displayFeaturedPropertyGroup(this.propertyGroup); // dyn2 - immediately

            // Remove loading
            $("#loading-wrapper").remove();
            $('body').removeClass('loading-active');
        }
        else {
	        // May still be items to display outside of FOV
            // Not disabled for mobile devices
            if (!this.propertySearchModel.noMap) {
                // Set map markers (outside radius)
                if (data.resultMapOutsideItems != null) {
                    for (var i = 0; i < data.resultMapOutsideItems.length; i++) {
                        // Add marker to map
                        addPropertyOutsideMarker(data.resultMapOutsideItems[i]);
                    }
                }

                // Set marker clustering
                setPropertyMarkerClusters();
            }

            // Display no matches
            let noResultsHtml = "<div class=\"property-card property-card__full\">";
            noResultsHtml += "<div class=\"property-card-details-wrapper no-records\">";
            noResultsHtml += "<p class=\"summary\">There are currently no matching properties to display</p>";
            noResultsHtml += "<p>Please refine your search criteria and try again</p>";
            noResultsHtml += "</div>";
            noResultsHtml += "</div>";
            $(noResultsHtml).appendTo('.dyn-search-group1');

            // Remove loading
            $("#loading-wrapper").remove();
            $('body').removeClass('loading-active');
        }
    }

    getTouches = (evt) => {
        return evt.touches ||             // browser API
               evt.originalEvent.touches; // jQuery
    }

    handleTouchStart = (evt) => {
        evt.preventDefault();
        const firstTouch = this.getTouches(evt)[0];                                      
        this.xDown = firstTouch.clientX;                                      
        this.yDown = firstTouch.clientY;
    };

    handleTouchEnd = (evt) => {
    };
                                                                             
    handleTouchMove = (evt) => {
        if ( ! this.xDown || ! this.yDown ) {
            return;
        }    
        var xUp = evt.touches[0].clientX;                                    
        var yUp = evt.touches[0].clientY;    
        var xDiff = this.xDown - xUp;
        var yDiff = this.yDown - yUp;                                                                             
        if ( Math.abs( xDiff ) > Math.abs( yDiff ) ) {
            if ( xDiff > 0 ) {
                const imageContainer = evt.target.closest(".property-card-image-wrapper");
                if (imageContainer !== null) {
                    const btnToClick = imageContainer.querySelectorAll('.next-arrow-img');
                    if (btnToClick.length > 0) {
                        btnToClick[0].click();
                    }
                }                
            } else {
                const imageContainer = evt.target.closest(".property-card-image-wrapper");
                if (imageContainer !== null) {
                    const btnToClick = imageContainer.querySelectorAll('.prev-arrow-img');
                    if (btnToClick.length > 0) {
                        btnToClick[0].click();
                    }
                }                
            }                       
        }
        this.xDown = null;
        this.yDown = null;                                             
    };
    
    getPropertySearchFromInfiniteScroll = (callback) => {
        let bmApiUrl = window['__appConfig'].apiUrl;

        // Perform the API call
        $.ajax({
            url: `${bmApiUrl}api/3.0/PropertySearch/GetPropertySearch/`,
            type: "POST",
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            data: JSON.stringify(this.propertySearchModel),
            cache: false,
            crossDomain: true,
            xhrFields: {
                withCredentials: true
            },
            success: function (r) {
                console.log(`getPropertySearchFromInfiniteScroll success`);
                callback(r);
            },
            error: function (e) {
                console.log(e);
                callback(e);
            }
        });
    }

    displayPropertySearchFromInfiniteScroll = (data: PropertySearchResultV3Model) => {
        console.log(`displayPropertySearchFromInfiniteScroll start`);
        let bmCdnUrl = window['__appConfig'].cdnUrl;

        if (data.resultItems.length > 0) {
            for (var i = 0; i < data.resultItems.length; i++) {
                let pItem = this.writePropertyItem(data.resultItems[i], bmCdnUrl, this.propertySearchModel.priceFrequencyId, 3);
                $(pItem).appendTo('.dyn-search-group2');
            }
            
            $('.property-image-carousel .next-arrow-img, .property-image-carousel-nosplit .next-arrow-img').click(function (e) {
                e.preventDefault();
                const wrapper = $(this).parent();
                const imageContainer = $(wrapper).find('.property-image-carousel-items');
                let image = $(wrapper).find('.property-image-carousel-item').first();
                $(image).remove();
                $(image).appendTo(imageContainer);
            });

            $('.property-image-carousel .prev-arrow-img, .property-image-carousel-nosplit .prev-arrow-img').click(function (e) {
                e.preventDefault();
                const wrapper = $(this).parent();
                const imageContainer = $(wrapper).find('.property-image-carousel-items');
                let image = $(wrapper).find('.property-image-carousel-item').last();
                $(image).remove();
                $(image).prependTo(imageContainer);
            });

            this.performCardAutoHeight(3);
            this.displayFeaturedPropertyGroup(this.propertyGroup);
        } else {
            this.infiniteScrollEof = true;
            $('#dyn-scroll-to-load-more').fadeOut(100);
        }

        this.setupImageDraggableEvents();

        this.infiniteScrollActive = false;
    }

    setupImageDraggableEvents = () => {
        var carouselElements = document.getElementsByClassName("newlyAddedCell");
        for (var i = 0; i < carouselElements.length; i++) {
            carouselElements[i].addEventListener('touchstart', this.handleTouchStart, false);
            carouselElements[i].addEventListener('touchmove', this.handleTouchMove, false);
            carouselElements[i].addEventListener('touchend', this.handleTouchEnd, false);
        }
        for (var i = 0; i < carouselElements.length; i++) {
            carouselElements[i].classList.remove("newlyAddedCell");
        }
    }
    
    infiniteScroll = (cancel: boolean) => {
        if (!this.infiniteScrollActive && !this.infiniteScrollEof){
            this.infiniteScrollActive = true;

            if (this.propertySearchModel.pageNo == null || this.propertySearchModel.pageNo == undefined || this.propertySearchModel.pageNo === 0) { this.propertySearchModel.pageNo = 1; }
            let currentPageNo = this.propertySearchModel.pageNo;
            this.propertySearchModel.pageNo = currentPageNo + 1;
            console.log("infiniteScroll " + currentPageNo + "_" + this.propertySearchModel.pageNo);

            // Run the search automatically
            this.getPropertySearchFromInfiniteScroll(this.displayPropertySearchFromInfiniteScroll);
        }
    }
    
    resetInfiniteScroll = () => {
        this.infiniteScrollActive = false;
        this.infiniteScrollEof = false;
        $('#dyn-scroll-to-load-more').fadeIn(100);
        
        this.resetAllFeaturedPropertyGroups();
    }

    resetAllFeaturedPropertyGroups = () => {
        this.propertyGroup = 1;
        $('.featured-properties-block').each(function() {
            $(this).remove();
        });
    }

    displayFeaturedPropertyGroup = (grpId: number) => {
        var groupItems = $(".featured-property-card").filter(function(){
            return parseInt($(this).data('propertygroup')) === grpId;
        });
        if (groupItems.length > 0) {
            var featurePropsRaw = "";
            if (this.propertySearchModel.gridViewMode === '1x') {
                featurePropsRaw += "<div class=\"featured-properties-block\">";
            } else {
                featurePropsRaw += "<div class=\"featured-properties-block full-width\">";
            }            
            featurePropsRaw += "        <h3 class=\"block-title mobile-centred\">Featured Properties</h3>";
            featurePropsRaw += "        <div id=\"list-featured-properties-group"+ grpId.toString() +"\" class=\"row\">";
            featurePropsRaw += "        </div>";
            featurePropsRaw += "</div>";
            if (grpId === 1) {
                $(featurePropsRaw).appendTo('#dyn-search-featured-group1');
            } else {
                $(featurePropsRaw).appendTo('#dyn-search-group2');
            }

            groupItems.each(function() {
                $(this).clone().appendTo(("#list-featured-properties-group"+ grpId.toString()));
            });
            this.propertyGroup = grpId + 1;
            this.performCardAutoHeight(4);
        }        
    }

    performCardAutoHeight(zoneId: number): void {
        if (zoneId === 4) {
            heightCheck('.property-height-check-4');
        } else {
            if (this.propertySearchModel.gridViewMode === "1x") return;
            switch(zoneId) {
                case 1:
                    heightCheck('.property-height-check-1');
                    break;
                case 2:
                    heightCheck('.property-height-check-2');
                    break;
                case 3:
                    heightCheck('.property-height-check-3');
                    break;
                default:
                    break;
            }
        }
    }

    writePropertyItem(p1: PropertySearchListingV3Model, cdnUrl: string, priceTypeId: number, zoneId: number) {
        // Is added to shortlist
        let isShortlisted = this.isPropertyShortlisted(p1.id);
        let isShortlistedClass = isShortlisted == true ? " icon-active" : " icon-inactive";

        // Property
        let isResidential = p1.isResidential;
        let isResidentialSale = p1.isResidentialSale;
        let isResidentialLetting = p1.isResidentialLetting;
        let isCommercial = p1.isCommercial;
        let isAgricultural = p1.isAgricultural;

        // Address
        const propAddress = p1.propertyAddress;

        let townPostcode = propAddress.lineTwo != null && propAddress.lineTwo.length > 0 ? propAddress.lineTwo : propAddress.town;
        townPostcode += townPostcode.length > 0 ? ", " : "";
        if (propAddress.town != null && propAddress.town.length > 0) {
            townPostcode += propAddress.town;
        }
        townPostcode += townPostcode.length > 0 ? ", " : "";
        if (propAddress.postcode != null && propAddress.postcode.length > 0) {
            townPostcode += propAddress.postcode;
        }

        // Key features
        let keyFeatures1 = "";
        let maxFeatures = 4;
        if (maxFeatures > p1.features.length) { maxFeatures = p1.features.length; }

        for (let i = 0; i < maxFeatures; i++) {
            let feature = p1.features[i];
            keyFeatures1 += "<li>" + feature.description.trim().replace('&#38;', '&').replace('&#163;', '£') + "</li>";
        }

        // Residential
        let bathrooms = "";
        let bedrooms = "";
        let dimensions = "";
        let priceQualifier = "";
        let priceLabel = "";
        let priceValue = "";
        let availability = "";
        let availabilityClass = "";
        let webStatusSoleOrLet = false;

        const letOrSoldDesignations = [1, 3, 5, 101, 104];
        const letOrSoldDesignationExists = _.indexOf(letOrSoldDesignations, p1.webStatus) > -1;
        
        if (isResidential == true) {

            // Beds and Bathrooms
            bathrooms = "<li><i class=\"fas fa-bath\"></i> " + p1.bathrooms + "</li>";
            bedrooms = "<li><i class=\"fas fa-bed\"></i> " + p1.bedrooms + "</li>";

            // Sales
            if (isResidentialSale == true) {

                // Availability
                availability = p1.webStatusDescription;
                availabilityClass = p1.availabilityStatus;

                // Price
                priceQualifier = p1.priceQualifier != null && p1.priceQualifier.length > 0
                    ? p1.priceQualifier
                    : "Asking Price";
                
                priceValue = p1.priceDisplay ? p1.priceFormatted : "POA";
            }

            // Lettings
            if (isResidentialLetting == true) {

                // Availability
                availability = p1.webStatusDescription;
                availabilityClass = p1.availabilityStatus;

                priceQualifier = "";

                if (p1.priceRent !== "") {
                    priceValue = p1.priceDisplay ? p1.priceFormatted  + " " + p1.priceRent : "POA";
                } else {
                    priceValue = p1.priceDisplay ? p1.priceFormatted : "POA";
                }

                if (p1.priceDisplay && !!p1.students && p1.students === true) {
                    if (!!p1.pricePppwFormatted && p1.pricePppwFormatted !== "" && p1.pricePppwFormatted.length > 0) {
                        priceValue = p1.pricePppwFormatted + " PPPW";
                    }
                }
            }
        }

        if (isCommercial == true) {

            // Availability
            availability = p1.webStatusDescription;
            availabilityClass = p1.availabilityStatus;

            // Price
            priceQualifier = p1.priceQualifier != null && p1.priceQualifier.length > 0
                    ? p1.priceQualifier
                    : "Asking Price";
            
            if (p1.priceRent !== "") {
                priceValue = p1.priceDisplay ? p1.priceFormatted  + " " + p1.priceRent : "POA";
            } else {
                priceValue = p1.priceDisplay ? p1.priceFormatted : "POA";
            }
        }

        if (isAgricultural == true) {

            // Availability
            availability = p1.webStatusDescription;
            availabilityClass = p1.availabilityStatus;

            // Price
            priceQualifier = p1.priceQualifier != null && p1.priceQualifier.length > 0
                    ? p1.priceQualifier
                    : "Asking Price";
            
            if (p1.priceRent !== "") {
                priceValue = p1.priceDisplay ? p1.priceFormatted  + " " + p1.priceRent : "POA";
            } else {
                priceValue = p1.priceDisplay ? p1.priceFormatted : "POA";
            }
        }

        priceLabel = p1.bedrooms + " Bedroom " + p1.typeOneFormatted;

        const galleryItems = _.filter(p1.propertyAssets, ['typeID', 0]);

        let propertyStructName = "";
        let propertyCardName = "";
        let propertyCarouselClassList = "";

        switch (this.propertySearchModel.gridViewMode){
            case "2x":
                propertyStructName = "col-xs-12 col-md-6";
                propertyCardName = "property-card property-card__2";
                propertyCarouselClassList = "property-card-image-wrapper property-image-carousel-nosplit";
                break;
            case "3x":
                propertyStructName = "col-xs-12 col-sm-6 col-md-4";
                propertyCardName = "property-card property-card__3";
                propertyCarouselClassList = "property-card-image-wrapper property-image-carousel-nosplit";
                break;
            default:
                propertyStructName = "";
                propertyCardName = "property-card property-card__full";
                propertyCarouselClassList = "property-card-image-wrapper property-image-carousel";
                if (galleryItems.length < 3) {
                    propertyCarouselClassList = "property-card-image-wrapper property-image-carousel-nosplit";
                }
                break;
        }

        let propHtml = "";
        if (propertyStructName !== "") {
            propHtml += "<div class=\""+ propertyStructName +"\">";
        }

            propHtml += "<div class=\""+ propertyCardName +"\">";
            if (letOrSoldDesignationExists && availability !== "") {
                propHtml += "    <div class=\"btn round-pink round-pink--small property-card-status\">" + availability + "</div>";
            }
            propHtml += "    <div class=\"property-card-content-wrapper\">";
            propHtml += "       <div class=\"" + propertyCarouselClassList + "\">";
            propHtml += "           <div class='property-image-carousel-items'>";

             galleryItems.forEach(function (asset: PropertyAssetViewModel) {
                propHtml += "         <div class=\"carousel-cell property-image-carousel-item newlyAddedCell\">";
                propHtml += "            <a href=\"/property/" + p1.url + "/\" class=\"listing-details-image-link\" data-url=\"/property/" + p1.url + "/\">";
                propHtml += "              <img data-link-url=\"/property/" + p1.url + "/\" src=\"" + asset.source + "\" style=\"opacity: 1;\" />";
                propHtml += "           </a>";
                propHtml += "        </div>";
             });
            propHtml += "           </div>";

            propHtml += "           <a class='next-arrow-img'></a><a class='prev-arrow-img'></a>";
            propHtml += "       </div>";
            propHtml += "       <div class=\"property-card-details-wrapper pc-three-wide-centre\">";
            propHtml += "         <div class=\"property-height-check-"+ zoneId + "\">";
            propHtml += "           <p class=\"summary\">"+ priceLabel +"</p>";

            if (priceQualifier !== "") {
                propHtml += "           <p class=\"qualifier-summary\">"+ priceQualifier +"</p>";
            }

            propHtml += "           <div class=\"meta\">";
            propHtml += "               <div>";
            propHtml += "                   <h4>"+ priceValue +"</h4>";
            propHtml += "               </div>";
            propHtml += "               <div>";
            propHtml += "                   <ul class=\"size\">";
            propHtml +=                        bathrooms;
            propHtml +=                        bedrooms;
            propHtml += "                   </ul>";
            propHtml += "                </div>";
            propHtml += "            </div>";
            propHtml += "            <p class=\"full-address\">" + propAddress.street + ", " + townPostcode + "</p>";
            if (this.propertySearchModel.gridViewMode === '1x') {
                propHtml += "            <ul class=\"features\">"+ keyFeatures1 +"</ul>";
            }
            propHtml += "          </div>";
            propHtml += "          <div class=\"action\">";
            propHtml += "              <a href=\"/property/" + p1.url + "/\" class=\"btn round-blue round-blue--small\">Full Details</a>";
            propHtml += "          </div>";
            propHtml += "        </div>";
            propHtml += "    </div>";
            propHtml += "</div>";

        if (propertyStructName !== "") {
            propHtml += "</div>";
        }
        
        return propHtml;
    }
    
    isPropertyShortlisted(id: number): boolean {
        var lsShortlist = [];
        var lsShortlistStr = localStorage.getItem("bm-pty-short");
        if (lsShortlistStr != null && lsShortlistStr != undefined) {
            lsShortlist = JSON.parse(lsShortlistStr);
        }
        const lsShortlistd = _.indexOf(lsShortlist, id);
        return lsShortlistd > -1;
    }
    
    setUiThread = () => {
        // Reset categories based upon loaded model
        this.resetPrimaryCategories();

        this.setPriceFrequencyId(this.getPriceTypeId());

        this.setUiFilterLabels();

        $('.let-agreed-wrap').fadeIn();
        if (this.getSearchCategory() === 'students') {
            $('.let-agreed-wrap').fadeIn();
        }
    }

    setUiFilterLabels = () => {
        // Prices
        this.setPriceFilterUi();

        // Property types
        /*let typesLabel = 'All property types';
        if (this.propertySearchModel.propertyTypes.length > 0) {
            typesLabel = '';
            for (var i = 0; i < this.propertySearchModel.propertyTypes.length; i++) {
                let typeRecord = _.find(this.propertyTypeOptions, ['key', this.propertySearchModel.propertyTypes[i]]);
                if (typesLabel.length > 0) { typesLabel += ', '; }
                typesLabel += typeRecord.value;
            }
        }
        if (typesLabel.length > 30) { typesLabel = typesLabel.substr(0, 30) + "..."; }
        $('#psearch-btn-type').text(typesLabel);*/

        // Bedrooms
        $('#psearch-btn-beds').val(this.getBedroomsMin());
        $('#psearch-beds-min').val(this.getBedroomsMin());
        /*let bedroomLabel = 'All bedrooms';
        if (this.propertySearchModel.bedroomsMin > 0) {
            bedroomLabel = `${this.propertySearchModel.bedroomsMin}+ bedrooms`;
        }
        $('#psearch-btn-beds').text(bedroomLabel);*/

        // Geo Locations
        if (this.propertySearchModel.searchGeos != null && this.propertySearchModel.searchGeos.length > 0) {
            for (var i = 0; i < this.propertySearchModel.searchGeos.length; i++) {
                var loc = this.propertySearchModel.searchGeos[i];
                addPill({
                    place_id: loc.placeId,
                    type_id: loc.typeId,
                    name: loc.name,
                    vicinity: loc.vicinity,
                    mainText: loc.mainText,
                    scope: loc.scope,
                    lat: loc.latitude,
                    lng: loc.longitude
                }, 2);
            }
        }

        // Search radius ddl
        $('#psearch-btn-radius').val(this.getSearchRadius());
        $('#psearch-radius').val(this.getSearchRadius());
        /*let radiusLabel = 'Radius';
        if (this.propertySearchModel.searchRadius >= 0) {
            let radiusRecord = _.find(this.radiusOptions, ['key', this.propertySearchModel.searchRadius]);
            radiusLabel = radiusRecord.value;
        }
        $('#psearch-btn-radius').text(radiusLabel);*/

        // Grid view mode (gridViewMode)
        $(".search-results-toggle-view-item").removeClass("active");
        $((".data-view-mode-" + this.getGridViewMode())).addClass("active");

        if (!this.propertySearchModel.noMap) {
            $(".data-view-mode-map").addClass("active");
        }

        // Save search model to localStorage
        localStorage.setItem("bm-pty-search", JSON.stringify(this.propertySearchModel));
    }

    setPriceFilterUi = () => {
        let priceLabel = 'All prices';
        let priceTypeId = this.getPriceTypeId();
        let priceTypeLabel = "";
        if (priceTypeId === 2) { priceTypeLabel = " PCM"; }
        if (priceTypeId === 3) { priceTypeLabel = " PW"; }
        if (priceTypeId === 4) { priceTypeLabel = " PPPW"; }

        /*if (this.propertySearchModel.priceMax === 0) {
            if (this.propertySearchModel.priceMin !== 0) {
                priceLabel = `More than ${this.formatPriceShort(this.propertySearchModel.priceMin, priceTypeId, true)}${priceTypeLabel}`;
            }
        }
        else if (this.propertySearchModel.priceMin === 0) {
            priceLabel = `Less than ${this.formatPriceShort(this.propertySearchModel.priceMax, priceTypeId, true)}${priceTypeLabel}`;
        }
        else if (this.propertySearchModel.priceMin > 0 && this.propertySearchModel.priceMax > 0) {
            priceLabel = `${this.formatPriceShort(this.propertySearchModel.priceMin, priceTypeId, true)} to ${this.formatPriceShort(this.propertySearchModel.priceMax, priceTypeId, true)}${priceTypeLabel}`;
        }*/
        /*$('#psearch-btn-price').text(priceLabel);*/

        // Reset labels for the current min/max +/- buttons
        $('#psearch-price-low').val(this.propertySearchModel.priceMin);
        $('#psearch-btn-price-low').val(this.propertySearchModel.priceMin);

        $('#psearch-price-max').val(this.propertySearchModel.priceMax);
        $('#psearch-btn-price-max').val(this.propertySearchModel.priceMax);
    }
    
    setUiMap = () => {
        initPropertySearchMap(
            this.propertySearchModel.mapLatitude,
            this.propertySearchModel.mapLongitude,
            this.propertySearchModel.mapZoom,
            this.propertySearchModel.mapRadius,
            this.mapGeofenceChanged
        );
    }
    
    setMapCentroid = (lat: number, lng: number) => {
        this.propertySearchModel.mapLatitude = lat;
        this.propertySearchModel.mapLongitude = lng;

        initPropertySearchMap(
            this.propertySearchModel.mapLatitude,
            this.propertySearchModel.mapLongitude,
            this.propertySearchModel.mapZoom,
            this.propertySearchModel.mapRadius,
            this.mapGeofenceChanged
        );
    }
    
    delayedLoadMapWithCoords = (lat: number, lng: number) => {
        this.propertySearchModel.mapLatitude = lat;
        this.propertySearchModel.mapLongitude = lng;

	    initPropertySearchMap(
            this.propertySearchModel.mapLatitude,
            this.propertySearchModel.mapLongitude,
            this.propertySearchModel.mapZoom,
            this.propertySearchModel.mapRadius,
            this.mapGeofenceChanged
        );
        this.executeQuickSearch();
    }
    
    mapBoundsChanged = (lat: number, lng: number, radius: number, zoom: number) => {
        // console.log(`mapBoundsChanged: ${lat} - ${lng} - ${radius} - ${zoom}`);
        this.propertySearchModel.mapLatitude = lat;
        this.propertySearchModel.mapLongitude = lng;
        this.propertySearchModel.mapRadius = radius;
        this.propertySearchModel.mapZoom = zoom;

        // Update the page number
        this.propertySearchModel.pageNo = 1;

        // Run the search automatically
        this.executeAdvancedSearch();
    }

    mapGeofenceChanged = (paths: CoordinateModel[]) =>  {
        // console.log(`mapGeofenceChanged: ${paths}`);
        this.propertySearchModel.coordinates = paths;

        // Update the page number
        this.propertySearchModel.pageNo = 1;       

        // Run the search automatically
        this.executeAdvancedSearch();
    }

    resetAllGeofences = () => {
        // console.log(`resetAllGeofences`);
        this.propertySearchModel.coordinates = [];
    }
    
    // [type: 1 = sale, 2 = letting]
    formatPriceShort = (cost: number, type: number, currency: boolean) => {
        let result = currency == true ? '£' : '';
        if (type === 1) {
            let saleValue = _.find(this.salePrices, ['key', cost]);
            result += saleValue.value;
        } else if (type === 2) {
            let lettingValue = _.find(this.lettingPrices, ['key', cost]);
            result += lettingValue.value;
        } else if (type === 3) {
            let lettingWeeklyValue = _.find(this.lettingWeeklyPrices, ['key', cost]);
            result += lettingWeeklyValue.value;
        } else if (type === 4) {
            let studentWeeklyValue = _.find(this.studentWeeklyPrices, ['key', cost]);
            result += studentWeeklyValue.value;
        }
        return result;
    }
    
    getIsHomePage = () => {
        return this.isHomePage;
    }
    
    resetPrimaryCategories = () => {
        this.setSearchDepartment(this.propertySearchModel.departmentName != null ? this.propertySearchModel.departmentName : 'residential');
        this.setSearchLocation(this.propertySearchModel.location);

        let category = this.propertySearchModel.categoryName != null ? this.propertySearchModel.categoryName : 'sales';
        this.setSearchCategory(category);
        $('.search-scat').prop('checked', false);
        $(".search-scat[value='" + category + "']").prop('checked', true);
    }
    
    getSearchDepartment = () => {
    	return $('#hdnSearchDepartmentName').val().toString();
    }
    
    setSearchDepartment = (department: string) => {
        this.propertySearchModel.departmentName = department;
        $('#hdnSearchDepartmentName').val(department);
    }

    getSearchCategory = () => {
        return $('#hdnSearchCategoryName').val().toString();
    }

    setSearchCategory = (category: string) => {
        this.propertySearchModel.categoryName = category;
        $('#hdnSearchCategoryName').val(category);

        // Set include sold items when sales
        if (category === 'sales' || category === 'lettings') {
            // this.propertySearchModel.includeLetOrSold = true;
        }
    }

    getSearchLocation = () => {
        return $('#psearch-locality').val() != null && $('#psearch-locality').val() != undefined && $('#psearch-locality').val() != ''
            ? $('#psearch-locality').val().toString()
            : '';
    }
    setSearchLocation = (location: string) => {
        this.propertySearchModel.location = location;
        $('#hdnSearchLocationName').val(location);
    }

    getSearchRadius = () => {
        return this.propertySearchModel.searchRadius;
    }
    setSearchRadius = (entry: number) => {
        this.propertySearchModel.searchRadius = entry;
        this.setUiFilterLabels();
    }
    
    setPriceMin = (lower: number) => {
        this.propertySearchModel.priceMin = 0;
        // if (lower > 0) {
        //     this.propertySearchModel.priceMin = lower;
        // }
        this.propertySearchModel.priceMin = lower;
        this.setUiFilterLabels();
    }
    setPriceMax = (upper: number) => {
        this.propertySearchModel.priceMax = 0;
        // if (upper > 0) {
        //     this.propertySearchModel.priceMax = upper;
        // }
        this.propertySearchModel.priceMax = upper;
        this.setUiFilterLabels();
    }
    
    setPriceFrequencyId = (freqId: number) => {
        this.propertySearchModel.priceFrequencyId = freqId;
        this.setSearchMinMaxValues(freqId);
        this.setPriceFilterUi();
    }

    getPriceTypeId = () => {
        let catid = this.getSearchCategory();
        if (catid == "students") { return 4; }
        let typeId = catid == "lettings" ? 2 : 1;
        if (typeId == 2 && this.propertySearchModel.priceFrequencyId == 3) { typeId = 3; }
        return typeId;
    }
    getBedroomsMin = () => {
        return this.propertySearchModel.bedroomsMin;
    }
    setBedroomsMin = (rooms: number) => {
        this.propertySearchModel.bedroomsMin = 0;
        if (rooms > 0) {
            this.propertySearchModel.bedroomsMin = rooms;
        }
        this.setUiFilterLabels();
    }

    getPropertyType = () => {
        return this.propertySearchModel.propertyTypes;
    }
    setPropertyType = (tid: number) => {
        this.propertySearchModel.propertyTypes = [];
        if (tid > 0) {
            this.propertySearchModel.propertyTypes.push(tid);
        }
        this.setUiFilterLabels();
    }
    
    loadLettingPrices = () => {
        this.lettingPrices.push({ key: 0, value: 'No min' });
        this.lettingPrices.push({ key: 300, value: '300' });
        this.lettingPrices.push({ key: 350, value: '350' });
        this.lettingPrices.push({ key: 400, value: '400' });
        this.lettingPrices.push({ key: 450, value: '450' });
        this.lettingPrices.push({ key: 500, value: '500' });
        this.lettingPrices.push({ key: 550, value: '550' });
        this.lettingPrices.push({ key: 600, value: '600' });
        this.lettingPrices.push({ key: 650, value: '650' });
        this.lettingPrices.push({ key: 700, value: '700' });
        this.lettingPrices.push({ key: 750, value: '750' });
        this.lettingPrices.push({ key: 800, value: '800' });
        this.lettingPrices.push({ key: 850, value: '850' });
        this.lettingPrices.push({ key: 900, value: '900' });
        this.lettingPrices.push({ key: 950, value: '950' });
        this.lettingPrices.push({ key: 1000, value: '1,000' });
        this.lettingPrices.push({ key: 1200, value: '1,200' });
        this.lettingPrices.push({ key: 1500, value: '1,500' });
        this.lettingPrices.push({ key: 2000, value: '2,000' });
        this.lettingPrices.push({ key: 2500, value: '2,500' });
        this.lettingPrices.push({ key: 3000, value: '3,000' });
        this.lettingPrices.push({ key: 0, value: 'No max' });
    }

    loadLettingWeeklyPrices = () => {
        this.lettingWeeklyPrices.push({ key: 0, value: 'No min' });
        this.lettingWeeklyPrices.push({ key: 300, value: '70' });
        this.lettingWeeklyPrices.push({ key: 350, value: '80' });
        this.lettingWeeklyPrices.push({ key: 400, value: '90' });
        this.lettingWeeklyPrices.push({ key: 450, value: '100' });
        this.lettingWeeklyPrices.push({ key: 500, value: '115' });
        this.lettingWeeklyPrices.push({ key: 550, value: '125' });
        this.lettingWeeklyPrices.push({ key: 600, value: '140' });
        this.lettingWeeklyPrices.push({ key: 650, value: '150' });
        this.lettingWeeklyPrices.push({ key: 700, value: '160' });
        this.lettingWeeklyPrices.push({ key: 750, value: '175' });
        this.lettingWeeklyPrices.push({ key: 800, value: '185' });
        this.lettingWeeklyPrices.push({ key: 850, value: '195' });
        this.lettingWeeklyPrices.push({ key: 900, value: '210' });
        this.lettingWeeklyPrices.push({ key: 950, value: '220' });
        this.lettingWeeklyPrices.push({ key: 1000, value: '230' });
        this.lettingWeeklyPrices.push({ key: 1200, value: '275' });
        this.lettingWeeklyPrices.push({ key: 1500, value: '350' });
        this.lettingWeeklyPrices.push({ key: 2000, value: '460' });
        this.lettingWeeklyPrices.push({ key: 2500, value: '580' });
        this.lettingWeeklyPrices.push({ key: 3000, value: '700' });
        this.lettingWeeklyPrices.push({ key: 0, value: 'No max' });
    }

    loadStudentWeeklyPrices = () => {
        this.studentWeeklyPrices.push({ key: 0, value: 'No min' });
        this.studentWeeklyPrices.push({ key: 45, value: '45' });
        this.studentWeeklyPrices.push({ key: 55, value: '55' });
        this.studentWeeklyPrices.push({ key: 65, value: '65' });
        this.studentWeeklyPrices.push({ key: 75, value: '75' });
        this.studentWeeklyPrices.push({ key: 85, value: '85' });
        this.studentWeeklyPrices.push({ key: 95, value: '95' });
        this.studentWeeklyPrices.push({ key: 105, value: '105' });
        this.studentWeeklyPrices.push({ key: 115, value: '115' });
        this.studentWeeklyPrices.push({ key: 125, value: '125' });
        this.studentWeeklyPrices.push({ key: 135, value: '135' });
        this.studentWeeklyPrices.push({ key: 145, value: '145' });
        this.studentWeeklyPrices.push({ key: 155, value: '155' });
        this.studentWeeklyPrices.push({ key: 165, value: '165' });
        this.studentWeeklyPrices.push({ key: 175, value: '175' });
        this.studentWeeklyPrices.push({ key: 185, value: '185' });
        this.studentWeeklyPrices.push({ key: 195, value: '195' });
        this.studentWeeklyPrices.push({ key: 205, value: '205' });
        this.studentWeeklyPrices.push({ key: 225, value: '225' });
        this.studentWeeklyPrices.push({ key: 245, value: '245' });
        this.studentWeeklyPrices.push({ key: 265, value: '265' });
        this.studentWeeklyPrices.push({ key: 285, value: '285' });
        this.studentWeeklyPrices.push({ key: 300, value: '300' });
        this.studentWeeklyPrices.push({ key: 0, value: 'No max' });
    }

    loadSalePrices = () => {
        this.salePrices.push({ key: 0, value: 'No min' });
        this.salePrices.push({ key: 50000, value: '50,000' });
        this.salePrices.push({ key: 100000, value: '100,000' });
        this.salePrices.push({ key: 150000, value: '150,000' });
        this.salePrices.push({ key: 200000, value: '200,000' });
        this.salePrices.push({ key: 250000, value: '250,000' });
        this.salePrices.push({ key: 300000, value: '300,000' });
        this.salePrices.push({ key: 350000, value: '350,000' });
        this.salePrices.push({ key: 400000, value: '400,000' });
        this.salePrices.push({ key: 450000, value: '450,000' });
        this.salePrices.push({ key: 500000, value: '500,000' });
        this.salePrices.push({ key: 600000, value: '600,000' });
        this.salePrices.push({ key: 800000, value: '800,000' });
        this.salePrices.push({ key: 1000000, value: '1,000,000' });
        this.salePrices.push({ key: 2000000, value: '2,000,000' });
        this.salePrices.push({ key: 0, value: 'No max' });
    }

    // [auction, residential, commercial, agricultural]
    loadPropertyTypeOptions = () => {

        // Auction
        if (this.propertySearchModel.departmentName === 'auction') {
            // No items as type (department) not catered for in Jupix so using department type
            this.propertyTypeOptions.push({ key: 1, type: 'auction', value: 'Residential', icon: 'fa-home' });
            this.propertyTypeOptions.push({ key: 2, type: 'auction', value: 'Commercial', icon: 'fa-building' });
            this.propertyTypeOptions.push({ key: 3, type: 'auction', value: 'Agricultural', icon: 'fa-hammer' });
        }
        // Residential
        if (this.propertySearchModel.departmentName === 'residential') {
            this.propertyTypeOptions.push({ key: 1, type: 'residential', value: 'House', icon: 'fa-home' });
            this.propertyTypeOptions.push({ key: 2, type: 'residential', value: 'Apartment', icon: 'fa-building' });
            this.propertyTypeOptions.push({ key: 3, type: 'residential', value: 'Bungalow', icon: 'fa-home' });
            this.propertyTypeOptions.push({ key: 4, type: 'residential', value: 'New Development', icon: 'fa-map-marker' });
        }
        // Commercial
        if (this.propertySearchModel.departmentName === 'commercial') {
            this.propertyTypeOptions.push({ key: 1, type: 'commercial', value: 'Offices', icon: 'fa-building' });
            this.propertyTypeOptions.push({ key: 3, type: 'commercial', value: 'Business', icon: 'fa-building' });
            this.propertyTypeOptions.push({ key: 15, type: 'commercial', value: 'Warehouse', icon: 'fa-industry' });
            this.propertyTypeOptions.push({ key: 30, type: 'commercial', value: 'Industrial (land)', icon: 'fa-industry' });
            this.propertyTypeOptions.push({ key: 31, type: 'commercial', value: 'Office (land)', icon: 'fa-building' });
            this.propertyTypeOptions.push({ key: 35, type: 'commercial', value: 'Commercial (land)', icon: 'fa-building' });
            this.propertyTypeOptions.push({ key: 37, type: 'commercial', value: 'Conversions', icon: 'fa-home' });
            this.propertyTypeOptions.push({ key: 39, type: 'commercial', value: 'Commercial', icon: 'fa-building' });
        }
        // Agricultural
        if (this.propertySearchModel.departmentName === 'agricultural') {
            this.propertyTypeOptions.push({ key: 1, type: 'agricultural', value: 'Residential Farm', icon: 'fa-hammer' });
            this.propertyTypeOptions.push({ key: 2, type: 'agricultural', value: 'Commercial Farm', icon: 'fa-hammer' });
            this.propertyTypeOptions.push({ key: 5, type: 'agricultural', value: 'Livestock Farm', icon: 'fa-hammer' });
            this.propertyTypeOptions.push({ key: 6, type: 'agricultural', value: 'Arable Land', icon: 'fa-hammer' });
            this.propertyTypeOptions.push({ key: 7, type: 'agricultural', value: 'Bare Land', icon: 'fa-hammer' });
            this.propertyTypeOptions.push({ key: 8, type: 'agricultural', value: 'Grazing Land', icon: 'fa-hammer' });
            this.propertyTypeOptions.push({ key: 15, type: 'agricultural', value: 'Investment Land', icon: 'fa-hammer' });
            this.propertyTypeOptions.push({ key: 16, type: 'agricultural', value: 'Development Land', icon: 'fa-hammer' });
        }
    }
    
    loadRadiusOptions = () => {
        this.radiusOptions.push({key: 0, value: '+0 miles'});
        this.radiusOptions.push({key: 402, value: '+1/4 miles'});
        this.radiusOptions.push({key: 804, value: '+1/2 miles'});
        this.radiusOptions.push({key: 1608, value: '+1 miles'});
        this.radiusOptions.push({key: 3218, value: '+2 miles'});
        this.radiusOptions.push({key: 4828, value: '+3 miles'});
        this.radiusOptions.push({key: 8046, value: '+5 miles'});
        this.radiusOptions.push({key: 16093, value: '+10 miles'});
        this.radiusOptions.push({key: 24140, value: '+15 miles'});
        this.radiusOptions.push({key: 32186, value: '+20 miles'});
        this.radiusOptions.push({key: 48280, value: '+30 miles'});
        this.radiusOptions.push({key: 64373, value: '+40 miles'});
    }
    
    // [1 = Sale, 2 = Lettings PCM, 3 = Lettings PW, 4 = Students PPPW]
    setSearchMinMaxValues = (typeId: number) => {

        // Store in hdn field
        $('#hdnFilterPriceTypeId').val(typeId);

        // Show/hide price swicth (pcm/pw)
        $('.price-switch').css({ "display": "none" });
    }
    
    getGridViewMode = () => {
        return this.propertySearchModel.gridViewMode;
    }
    setGridViewMode = (mode: string) => {
        this.propertySearchModel.gridViewMode = mode;
        // this.setUiFilterLabels();
    }
    // setGridMapMode
    getNoMapState = () => {
        return this.propertySearchModel.noMap;
    }
    setNoMapState = (state: boolean) => {
        this.propertySearchModel.noMap = state;
        this.showHideMapControls();
        this.setUiFilterLabels();
    }

}

$(document).ready(function () {

    var propertySearch = new PropertySearchV5();
    propertySearch.run();

    // Run search
    $('#psearch-btn-submit, #psearch-mobile-btn-submit').on('click', function (e) {
        e.preventDefault();

        $("#psearch-fx").removeClass("mobile-filters-active");
        
        $('.psearch-zone').fadeOut(0);
        $('.psearch-container').removeClass("active-zone");
        $('.search-options-filters').removeClass("active-zone");
        $('.search-options').removeClass('active-filter');

        $("html, body").removeClass("no-scroll");

        $("html, body").animate({ scrollTop: 0 }, 1000);

        propertySearch.executeAdvancedSearch();
    });

    $("#psearch-locality").keyup(function (e) {
        if (e.which == 13) {
            e.preventDefault();

            $("#psearch-fx").removeClass("mobile-filters-active");

            $('.psearch-zone').fadeOut(0);
            $('.psearch-container').removeClass("active-zone");
            $('.search-options-filters').removeClass("active-zone");
            $('.search-options').removeClass('active-filter');

            $("html, body").removeClass("no-scroll");

            $("html, body").animate({ scrollTop: 0 }, 1000);

            propertySearch.executeAdvancedSearch();
        }
    });

    $(window).scroll(function () {
        var scrollHintToTop = $("#dyn-scroll-to-load-more").position().top;
        var currentScroll = $(this).scrollTop();
        if (currentScroll > (scrollHintToTop - 1000)) {
            propertySearch.infiniteScroll(false);
        }
    });

    // Pagination interaction
    $(document).on('click', '.pagination-action', function (e) {
        e.preventDefault();

        var pageNo = $(this).attr("data-pageno");
        if (window.history && window.history.pushState) {
            var stateObj = { pageNo: pageNo };
            var currentUrl = $(location).attr("href");
            history.pushState(stateObj, "Find a property - page " + pageNo, "./#p" + pageNo);
        }

        propertySearch.updatePagination(pageNo);
    });

    if (window.history && window.history.pushState) {
        $(window).on('popstate', function() {
            var stateObj = history.state;
            var pageNo = 1;
            if (stateObj != null && stateObj != undefined) {
                pageNo = stateObj.pageNo;
            }
            if (pageNo == null || pageNo == undefined || pageNo === 0) { pageNo = 1; }
            propertySearch.updatePagination(pageNo);
        });
    }

    // Radio buttons
    $('#search-include-soldorlet').click(function (e) {
        propertySearch.setIncludeLetOrSold($('#search-include-soldorlet').prop('checked'));
    });

    // Ordering changes
    $('#sort-select').change(function (e) {
        var orderx = parseInt($('#sort-select').val().toString());
        propertySearch.updateOrdering(orderx);
    });

    // Property listing on click event
    $(document).on('click', '.listing-details-image-link, .map-infowindow-image-link', function (e) {
        localStorage.setItem("bm-pty-from-search", "1");
    });
    $(document).on('click', '.listing-details-wrapper', function (e) {
        e.preventDefault();
        if ($(this).attr("data-url") !== undefined && $(this).attr("data-url").length > 0) {
            localStorage.setItem("bm-pty-from-search", "1");
            document.location.href = $(this).attr("data-url");
        }
    });

    // Locality input > psearch-locality
    // See 'search-interactions.js'

    var closeAllZones = () => {
        $('.psearch-zone').fadeOut(0);
        $('.psearch-container').removeClass("active-zone");
        $('.search-options-filters').removeClass("active-zone");
        $('.search-options').removeClass('active-filter');
    }
    var displayZone = (selector) => {
        $(selector).fadeIn(100);
        $(selector).parent().addClass("active-zone")
        $('.search-options').addClass('active-filter');
    }

    $('#psearch-locality').keyup(function (e) {
        var searchString = $('#psearch-locality').val().toString();
        if (searchString === '' || searchString.length <= 2) {
            closeAllZones();
        }
    });

    $('#psearch-locality').keydown(function (e) {
        if (!$("#psearch-fx").hasClass("mobile-filters-active")) {
            if ($(window).width() <= 1024 && $("#filterTrigger").length > 0) {
                $("html, body").addClass("no-scroll");
                $("#psearch-fx").addClass("mobile-filters-active");
            }
        }        
    });

    // Radius
    $('#psearch-btn-radius').change(function (e) {
        var radius = parseInt($('#psearch-btn-radius').val().toString());
        propertySearch.setSearchRadius(radius);
    });
    $('#psearch-btn-radius').on('click', function (e) {
        e.preventDefault();
        closeAllZones();
        /*displayZone('.psearch-picker-radius');*/
    });
    $('#psearch-radius').change(function (e) {
        var radius = parseInt($('#psearch-radius').val().toString());
        propertySearch.setSearchRadius(radius);
        closeAllZones();
    });

    // Price
    /*$('#psearch-btn-price').on('click', function (e) {
        e.preventDefault();
        closeAllZones();
        displayZone('.psearch-picker-price');
    });*/
    $('#psearch-btn-price-low').on('click', function (e) {
        e.preventDefault();
        closeAllZones();
    });
    $('#psearch-btn-price-low').change(function (e) {
        var pMin = parseInt($('#psearch-btn-price-low').val().toString());
        propertySearch.setPriceMin(pMin);
        closeAllZones();
    });
    $('#psearch-btn-price-max').on('click', function (e) {
        e.preventDefault();
        closeAllZones();
    });
    $('#psearch-btn-price-max').change(function (e) {
        var pMin = parseInt($('#psearch-btn-price-max').val().toString());
        propertySearch.setPriceMax(pMin);
        closeAllZones();
    });
    $('#psearch-price-low').change(function (e) {
        var pMin = parseInt($('#psearch-price-low').val().toString());
        propertySearch.setPriceMin(pMin);
        closeAllZones();
    });
    $('#psearch-price-max').change(function (e) {
        var pMax = parseInt($('#psearch-price-max').val().toString());
        propertySearch.setPriceMax(pMax);
        closeAllZones();
    });

    // PCM / PW change
    $('.price-switch-weekly').click(function (e) {
        $('.price-switch-monthly').removeClass("active");
        $('.price-switch-weekly').addClass("active");
        propertySearch.setPriceFrequencyId(3);
    });
    $('.price-switch-monthly').click(function (e) {
        $('.price-switch-weekly').removeClass("active");
        $('.price-switch-monthly').addClass("active");
        propertySearch.setPriceFrequencyId(2);
    });

    // Beds
    $('#psearch-btn-beds').change(function (e) {
        var beds = parseInt($('#psearch-btn-beds').val().toString());
        propertySearch.setBedroomsMin(beds);
    });
    $('#psearch-btn-beds').on('click', function (e) {
        e.preventDefault();
        closeAllZones();
        /*displayZone('.psearch-picker-beds');*/
    });
    $('#psearch-beds-min').change(function (e) {
        var beds = parseInt($('#psearch-beds-min').val().toString());
        propertySearch.setBedroomsMin(beds);
        closeAllZones();
    });

    // Property Type
    /*$('#psearch-btn-type').on('click', function (e) {
        e.preventDefault();
        closeAllZones();
        displayZone('.psearch-picker-type');
    });
    $('#psearch-type').change(function (e) {
        var typeId = parseInt($('#psearch-type').val().toString());
        propertySearch.setPropertyType(typeId);
        closeAllZones();
    });*/
    
    $('#psearch-picker-locality-select').change(function (e) {
        propertySearch.resetAllGeofences();
    });

    // Set grid view mode (gridViewMode)
    $(".search-results-toggle-view-item").click(function (e) {
        e.preventDefault();

        var mode = $(this).attr("data-view-mode");
        if (mode === undefined) return;

        var modeName = mode.toString();

        if (modeName === 'map') {
            if ($(this).hasClass("active")) {
                $(this).removeClass("active");
                propertySearch.setNoMapState(true);
            } else {
                $(this).addClass("active");
                propertySearch.setNoMapState(false);
            }
        } else {
            propertySearch.setGridViewMode(modeName);
            $(".search-results-toggle-view-item").removeClass("active");
            $(this).addClass("active");

            if (propertySearch.getNoMapState() === false) {
                $('.data-view-mode-map').addClass("active");
                propertySearch.setNoMapState(false);
            } else {
                propertySearch.setNoMapState(true);
            }
        }

        $("html, body").removeClass("no-scroll");
        propertySearch.executeAdvancedSearch();
    });

    $(window).resize(function () {
        propertySearch.performCardAutoHeight(1);
        propertySearch.performCardAutoHeight(2);
        propertySearch.performCardAutoHeight(3);
        propertySearch.performCardAutoHeight(4);
    });

});



// WEBPACK FOOTER //
// ./App/PropertySearchV5.ts